module.exports = __webpack_public_path__ + "static/media/3dot.1bfa2bc0.svg";